export default __webpack_public_path__ + "static/media/FdLsui1aMAMxvEK.a4344dbc.jpg";